<template>
  <div class="card shadow-sm">
    <div class="d-flex w-100 p-3 justify-content-between mt-1 border-bottom position-relative card-title-ido">
      <h5 class="fw-bold text-primary">设备排行</h5>
      <div class="point-curser">
        <span :class=" {'text-primary':status===1}" @click="changeStatus(1)">使用排行</span>
        <span class="me-2"></span>
        <span :class="{'text-primary':status===2}" @click="changeStatus(2)">预约排行</span>
      </div>
<!--      <a href="#" class="card-link text-primary" @click="more">更多</a>-->
    </div>
    <div class="list-box mt-2 d-flex align-items-center justify-content-center" v-if="loading || (!loading &&status===1 && list1.length<=0) || (!loading &&status===2 && list2.length<=0)">
      <!-- loading-->
      <div v-if="loading"  class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <!--              暂无数据-->
      <div v-if="(!loading &&status===1 && list1.length<=0) || (!loading &&status===2 && list2.length<=0)" class="text-secondary fw-bold" role="status">
        <span >暂无数据</span>
      </div>
    </div>

    <div class="list-box mt-2" v-else>
      <!--              数据-->
      <template v-if="status===1">
        <div class="d-flex w-100 py-2 px-3 justify-content-between flex-shrink-0" v-for="(item,index) of list1" :key="index">
          <div class="me-4 point-curser list-des fw-medium" @click="goDetail(item)">{{index+1}} &nbsp;&nbsp;
            {{item.Name}}</div>
          <div class="list-time text-primary">{{item.TotalUsage || 0}} 次</div>
        </div>
      </template>
      <template v-else>
        <div class="d-flex w-100 py-2 px-3 justify-content-between flex-shrink-0" v-for="(item,index) of list2" :key="index">
          <div class="me-4 point-curser list-des fw-medium" @click="goDetail(item)">{{index+1}} &nbsp;&nbsp;
            {{item.Name}}</div>
          <div class="list-time text-primary">{{item.TotalAppointment || 0}} 次</div>
        </div>
      </template>

    </div>
  </div>
</template>

<script setup>
import {onMounted, ref,computed,defineProps} from "vue";
import router from "@/router";
import {useStore} from 'vuex'
const store = useStore()
const list2 = computed(()=> store.state.homeModel.device_top_by_appointment)//设备排行 top 10。按照预约次数排序
const list1 = computed(()=> store.state.homeModel.device_top_by_usage)//设备排行 top 10。按照使用时长排序
const status = ref(1)
defineProps({
  loading:{
    default:true
  }
})
const more = () => {
  router.push({path:'/equipmentsharing'})
}
const goDetail = (item)=>{
  router.push({path:'/equipmentDetail',query:{id:item.ID}})

}
// 修改状态
const changeStatus = (s)=>{
  status.value = s
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/css/FirstPageListStyle.scss";
</style>
